import { useState } from 'react'

import { EMPTY_LIST } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { parseServerValidation } from '../../../../utils/validation'
import {
  addNewContact,
  getHasEmptyContact,
  getNewContactsInitialValues,
  getProfileContactsWidgetErrorNotificationKey,
  removeContactById,
} from '../ProfileContactsWidget.utils'
import {
  PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY,
  PROFILE_CONTACTS_WIDGET_VALUE_FIELD,
} from '../ProfileContactsWidgetListCell'

export function useProfileContactsWidgetCreateForm({ api, onCreated }) {
  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const [newContacts, setNewContacts] = useState(EMPTY_LIST)

  const initialValues = getNewContactsInitialValues(newContacts)

  function handleSelectItem(item) {
    setNewContacts(prev =>
      addNewContact({ newContacts: prev, typeConfig: item.typeConfig })
    )
  }

  function handleRemoveContact(contactId) {
    setNewContacts(prev => removeContactById({ contactId, newContacts: prev }))
  }

  function handleCancelCreate() {
    setNewContacts(EMPTY_LIST)
  }

  async function handleCreateSubmit(values, { setErrors, setSubmitting }) {
    if (getHasEmptyContact({ newContacts, values })) {
      setSubmitting(false)

      return
    }

    try {
      await Promise.all(
        newContacts.map(contact =>
          api.create({
            typeConfig: contact.typeConfig,
            value: values[contact.id][PROFILE_CONTACTS_WIDGET_VALUE_FIELD],
          })
        )
      )

      onCreated()
      setNewContacts(EMPTY_LIST)
      handleAddSuccessNotification(
        PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY.saved
      )
    } catch (error) {
      setSubmitting(false)
      setErrors(parseServerValidation(error))
      handleAddErrorNotification(
        getProfileContactsWidgetErrorNotificationKey(error)
      )
    }
  }

  return {
    handleCancelCreate,
    handleCreateSubmit,
    handleRemoveContact,
    handleSelectItem,
    initialValues,
    newContacts,
  }
}
